import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainHeader from 'components/navigation/MainHeader'
import ProxyContent from 'components/modules/products/proxy/ProxyContent'
import SubscriptionInfo from 'components/modules/settings/SubscriptionsInfo'

import { selectUserSubscriptionView } from 'store/user/selectors'
import { UserActionsTypes } from 'store/user/actions'
import { isSubscriptionActive } from 'utils/functions'
import { logAmplitudeEvent } from 'utils/analytics'

const ProxyPage: React.FC = () => {
  const crumbsItems = [
    {
      label: 'Overview',
      to: '/',
    },
    {
      label: 'Proxies',
      isActive: true,
    },
  ]

  const dispatch = useDispatch()

  const subscriptionInfo = useSelector(selectUserSubscriptionView)

  const isUserSubscriptionActive = isSubscriptionActive(subscriptionInfo)
  const isDemoModeAvailable = !subscriptionInfo?.status

  useEffect(() => {
    if (isDemoModeAvailable) {
      logAmplitudeEvent('Preview Proxies product view')
    }
  }, [])

  useEffect(() => {
    if (isUserSubscriptionActive) {
      dispatch({ type: UserActionsTypes.USER_GET_PROXY_PACKAGES })
    }
  }, [dispatch, isUserSubscriptionActive])

  return (
    <>
      <MainHeader crumbsItems={crumbsItems} />

      {isUserSubscriptionActive || isDemoModeAvailable ? (
        <ProxyContent />
      ) : (
        <SubscriptionInfo reducedDisplayMode />
      )}
    </>
  )
}

export default ProxyPage
